import { Navigate } from "react-router-dom";

const exportDefault = {
    checkWhatsApp(number) {
        const whatsappRegex = /^(?:\+|00)[1-9]\d{1,14}$/;
        return whatsappRegex.test(number);
    },
    checkPhone(number, isPhone = false) {
        if (isPhone) {
            const nineDigitRegex = /^0\d{8}$/;
            const thirteenDigitRegexPlus = /^(00|\+)\d{12}$/;
            const thirteenDigitRegex = /^00\d{11}$/;
            const twelveDigitRegex = /^\+\d{11}$/;
            const elevenDigitRegex = /^\d{11}$/;

            const tenDigitRegex = /^\d{10}$/;
            const fourteenDigitRegex = /^(00|\+)\d{12}$/;
            const twelveDigitRegexPlus = /^\+\d{12}$/;
            const twelveDigitRegexDigit = /^\d{12}$/;
            return (
                nineDigitRegex.test(number) ||
                thirteenDigitRegexPlus.test(number) ||
                thirteenDigitRegex.test(number) ||
                twelveDigitRegex.test(number) ||
                elevenDigitRegex.test(number) ||
                tenDigitRegex.test(number) ||
                fourteenDigitRegex.test(number) ||
                twelveDigitRegexPlus.test(number) ||
                twelveDigitRegexDigit.test(number)
            );

        }
        else {
            const tenDigitRegex = /^\d{10}$/;
            const fourteenDigitRegex = /^(00|\+)\d{12}$/;
            const twelveDigitRegexPlus = /^\+\d{12}$/;
            const twelveDigitRegex = /^\d{12}$/;
            return tenDigitRegex.test(number) || fourteenDigitRegex.test(number) || twelveDigitRegexPlus.test(number) || twelveDigitRegex.test(number);
        }
    },
    checkEmail(email) {
        let re =
            /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email + '');
    },
    logout() {
        localStorage.removeItem("traffic_user");
        localStorage.removeItem("traffic_token");
        window.location.href = "/"; // إعادة التوجيه يدويًا
    },
    validatePassword(password, t) {
        const minLength = /.{8,}/;
        const hasUpperCase = /[A-Z]/;
        const hasLowerCase = /[a-z]/;
        const hasNumber = /[0-9]/;
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;

        if (!minLength.test(password)) {
            return t('lenError')
        }
        if (!hasUpperCase.test(password)) {
            return t('capitalError');
        }
        if (!hasLowerCase.test(password)) {
            return t('smallError');
        }
        if (!hasNumber.test(password)) {
            return t('numberError');
        }
        if (!hasSymbol.test(password)) {
            return t('symbolError');
        }

        return null; // ✅ Valid password
    },
    cn(...classes) {
        return classes.filter(Boolean).join(" ");
    },
    getSuccessToast() {
        return {
            duration: 2000,
            position: "top-center",
            style: { background: "#4ade80", color: "#000" }
        }
    },
    getErrorToast() {
        return {
            duration: 2000,
            position: "top-center",
            style: { background: "#f87171", color: "#fff" }
        }
    },
    formatNumber(number) {
        let formattedNumber = new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(number);

        return formattedNumber;
    },
    formatDate(date, lang) {
        if (lang === "ar") {
            return new Date(date).toLocaleString("ar-EG", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        }
        else {
            return new Date(date).toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        }
    },
    formatShortDate(date) {
        const d = new Date(date);

        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();

        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    formatDateLocal(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    },
    hasPermission(user, permissionId) {
        if (!user) return false;
        // Admin bypass
        //if (user.Role === 1) return true;

        return user.Permissions?.some(p => p.Id === permissionId);
    },
    getShipmentStatusList(t) {
        const StatusList = [
            { Id: -1, Name: t('selectStatus') },
            { Id: 0, Name: t('draft') },
            { Id: 1, Name: t('new') },
            { Id: 2, Name: t('sent') },
            { Id: 3, Name: t('received') },
            { Id: 4, Name: t('mustReturn') },
            { Id: 5, Name: t('returnedToSupplier') },
            { Id: 6, Name: t('approved') },
        ];
        return StatusList
    }
}

export default exportDefault;